import styled from 'styled-components';
import { darken, rgba } from 'polished';

import BaseModal from '../Modal';

export const Dialog = styled(BaseModal)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 15px 20px 20px;
  width: min(900px, calc(100vw - 48px));
  max-width: 900px;
  max-height: 85vh;
  overflow: auto;
  font-family: 'Sora', sans-serif;

  header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;

    h3 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.black};
    }

    p {
      margin-top: 4px;
      color: ${({ theme }) => theme.colors.grey};
      font-size: 13px;
    }

    button {
      padding: 5px;
      background: none;
      border: none;
      font-size: 26px;
      color: ${({ theme }) => theme.colors.red};
      max-width: 36px;
      max-height: 36px;
      cursor: pointer;
      transition: color 0.2s ease;

      &:hover {
        color: ${({ theme }) => darken(0.3, theme.colors.red)};
      }
    }
  }
`;

export const Sizes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0 8px;
`;

export const SizeTab = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.main : theme.colors.lightGrey};
  background: ${({ theme, $active }) =>
    $active ? rgba(theme.colors.main, 0.1) : theme.colors.white};
  cursor: pointer;
  font-family: inherit;
  text-align: left;

  strong {
    color: ${({ theme }) => theme.colors.softBlack};
    font-weight: 600;
  }

  span {
    color: ${({ theme }) => theme.colors.grey};
    font-size: 12px;
  }
`;

export const Tables = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  padding: 12px 0 8px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.section`
  min-width: 0;

  h4 {
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.softBlack};
    font-size: 14px;
    font-weight: 700;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 8px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
    text-align: left;
    color: ${({ theme }) => theme.colors.softBlack};
    font-size: 13px;
  }

  th {
    font-weight: 600;
  }

  th.numeric,
  td.numeric {
    text-align: right;
    white-space: nowrap;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    font: inherit;
    font-weight: 600;
    cursor: pointer;
  }

  tbody tr:hover {
    background: ${({ theme }) => rgba(theme.colors.main, 0.05)};
  }
`;

export const Share = styled.span`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.grey};
`;

export const Empty = styled.p`
  padding: 16px 8px;
  color: ${({ theme }) => theme.colors.grey};
  font-size: 13px;
`;

export const ErrorText = styled.p`
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.red};
  font-size: 13px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 8px;

  button {
    display: flex;
    align-items: center;
    padding: 13px 18px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.main};
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;

    span {
      font-family: 'Sora', sans-serif;
      font-size: 15px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.white};
    }

    &:hover {
      background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
    }
  }
`;
